import { useState, useRef } from 'react'
import styled from 'styled-components'

import { translate } from '../../utils/translation'
import { palette } from '../../styles/variables'
import { useOnClickOutside } from '../../utils/useOnClickOutside'

import SideMenu from './sideMenu'
import { allItems } from './menuContent'
import Link from './link'
import NeilCard from './neilCard'

const Container = styled.div({
  padding: '24px 32px',
  boxShadow: '0px 4px 20px 4px rgba(0, 20, 60, 0.1)',
  background: palette.white,
  display: 'flex',
  gap: 20,
  maxWidth: '1134px',
  borderRadius: '4px',
})

const LinksGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  overflowY: 'auto',
  maxHeight: '80vh',
  paddingRight: '10px',
  gap: 4,
})

const LinkSubTitle = styled.h3({
  fontSize: '14px',
  lineHeight: '26px',
  color: palette.darkGray50,
  textTransform: 'uppercase',
  margin: '0px 0px 0px 14px',
})

const MegaMenu = ({ handleClose, isMouseInsideButton }) => {
  const [selectedMenu, setSelectedMenu] = useState('dataAnalytics')
  const containerRef = useRef(null)

  useOnClickOutside(containerRef, () => {
    if (!isMouseInsideButton) handleClose()
  })

  return (
    <Container ref={containerRef}>
      <SideMenu selected={selectedMenu} setSelected={setSelectedMenu} />
      <div>
        <LinkSubTitle>{translate('focus_areas')}</LinkSubTitle>
        <LinksGrid>
          {allItems[selectedMenu].links.map((link) => (
            <Link key={link.title} {...link} />
          ))}
        </LinksGrid>
      </div>
      <NeilCard {...allItems[selectedMenu].card} />
    </Container>
  )
}

export default MegaMenu
